import './AccessStatisticsLegend.scss';
import classNames from 'classnames';
import React from 'react';
import { Tag } from 'antd';
import { DATA_SENSITIVITY_COLORS, DATA_SENSITIVITY_LABELS } from '@sonar-software/sonar-core';
export const AccessStatisticsLegend = ({ classifications }) => React.createElement("div", { className: 'access-statistics-legend' }, Object.entries(DATA_SENSITIVITY_COLORS)
    .filter(([id]) => classifications === null || classifications === void 0 ? void 0 : classifications[Number(id)])
    .map(([id, color]) => React.createElement("div", { className: 'legend-item', key: id },
    React.createElement(Tag, { className: classNames('color-bar', color) }),
    DATA_SENSITIVITY_LABELS[Number(id)])));
